<div class="breadcrumbs">
  <span class="title" *ngIf="isDettaglio">Gestione Emergenze <mat-icon style="vertical-align: middle;">
      keyboard_arrow_right</mat-icon> Dettaglio template </span>
  <span class="title" *ngIf="isModifica">Gestione Emergenze <mat-icon style="vertical-align: middle;">
      keyboard_arrow_right</mat-icon> Modifica template </span>
  <span class="title" *ngIf="!isDettaglio && !isModifica">Gestione Emergenze <mat-icon style="vertical-align: middle;">
      keyboard_arrow_right</mat-icon> Nuovo template </span>
</div>
<hr>

<div class="titolo flex-row-titolo">
  <div class="flex-display">
    <button mat-stroked-button class="pers" (click)="onNavigate()">
      <mat-icon class="middle">keyboard_arrow_left</mat-icon>
    </button>
    <div class="denom">
    <span class="h5 upp">Dettaglio template {{templateName}}</span>
  </div>
  </div>

  <div class="combo">
    <button *ngIf="isModifica" mat-flat-button color='accent' class="pers3 mleft" (click)="upsertTemplate()">SALVA
      MODIFICHE</button>
  </div>

</div>

<div class="pers titles">
  <span class="title">
    TIPOLOGIA TEMPLATE SEGNALAZIONE
  </span>
</div>

<div class="flex-row">
  <mat-tab-group class="pers-tab-group" [color]="'accent'" mat-align-tabs="start">

    <mat-tab>
      <ng-template mat-tab-label>
        <strong>DESCRIZIONE</strong>
      </ng-template>

      <div class="form-flex-row" [formGroup]="form" style="margin-top:25px">
        <mat-form-field  [ngStyle]="{'pointer-events':checkPubblico? 'auto':'none'}" class="dettTemplForm" color="accent" appearance="fill">
          <mat-label class="big">Tipologia</mat-label>
          <mat-select [formControlName]="'tpModulo'" (openedChange)="alertConfirm($event)" (selectionChange)="inviaTpModCampi($event)" >
            <mat-option *ngFor="let tipologia of tipologie" [value]="tipologia.idTpTemplate === 0? null:tipologia.idTpTemplate">
              <span>
                {{ tipologia.descrTpTemplate }}
              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-error *ngIf="this.form.controls.tpModulo.errors && this.form.controls.tpModulo.touched">
          <mat-error *ngIf="this.form.controls.tpModulo.errors.required">Campo obbligatorio
          </mat-error>
        </mat-error>
      </div>

      <div class="form-flex-row" [formGroup]="form" *ngIf="this.formChanged || isDettaglio">
        <mat-form-field class="dettTemplForm" color="accent" appearance="fill">
          <mat-label class="big">Descrizione</mat-label>
          <input matInput [formControlName]="'descrizione'" required>
        </mat-form-field>
        <mat-error *ngIf="this.form.controls.descrizione.errors && this.form.controls.descrizione.touched">
          <mat-error *ngIf="this.form.controls.descrizione.errors.required">Campo obbligatorio
          </mat-error>
          <mat-error *ngIf="this.form.controls.descrizione.errors.maxlength">Il numero massimo di
            caratteri consentiti è 10</mat-error>
        </mat-error>
      </div>
    </mat-tab>
    <mat-tab *ngIf="this.formChanged && !isNewTemplate">
      <ng-template mat-tab-label>
        <strong>CAMPI</strong>
      </ng-template>
      <app-lista-campi-unica [tpM]="this.form.controls.tpModulo.value" (allCampiAbilitatiEvent)="sonoAbilitatiTuttiCampi($event)" (emitCampiPredConf)="fillCampiPredConf($event)" [campo]="campoSubject.asObservable()"></app-lista-campi-unica>
    </mat-tab>
    <mat-tab *ngIf="this.formChanged && !isNewTemplate">
      <ng-template mat-tab-label>
        <strong>ENTI ABILITATI ALLA COMPILAZIONE</strong>
      </ng-template>
      <app-lista-enti-abilitati [resetAbilitaTuttiEnti]="resetAbilitaTuttiEnti.asObservable()" (primaVoltaDistribuito)="primaVoltaRendiPubblico($event)" (emitEnteFilterDto)="getEnteFilterDto($event)" (sonoAbilitatiTuttiEntiEvent)="sonoAbilitatiTuttiEnti($event)" (sonoModStatoCompTuttiEntiEvent)="atLeastOneModStatoCompEntiEvent($event)" (emitEnteConfiguration)="fillEnti($event)" [ente]="enteSubject.asObservable()"></app-lista-enti-abilitati>
    </mat-tab>
  </mat-tab-group>
</div>
